import React from "react";
import { useTranslation } from "react-i18next";
import "./addPageView.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { websiteBuilderAddPage } from "redux/actions/websiteBuilder/editor/websiteBuilderEditor";
import { websiteBuilderGenerateDefaultRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/root/websiteBuilderRoot";
import { WebsiteBuilderToolbarMenuView } from "../../../WebsiteBuilderToolbarMenuView";
import { websiteBuilderSlugify } from "pages/secure/facility/websiteBuilder/editor/utility/websiteBuilderSlugify";
import { ButtonNew as Button } from "components/buttonNew";

interface IAddPageViewProps {
  disabled: boolean;
  goBackToParentView: () => void;
}

export function AddPageView(props: IAddPageViewProps) {
  const { disabled, goBackToParentView } = props;

  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const pages = useAppSelector(store => store.websiteBuilderStore.editor.pages);
  const websiteVersion = useAppSelector(store => store.websiteBuilderStore.editor.websiteVersion);

  function addBlankPage() {
    const baseTitle = t("Untitled");
    
    let title = baseTitle;
    let slug = websiteBuilderSlugify(title);
    
    let conflicts = 0;

    while (pages.some(page => page.title === title || page.slug === slug)) {
      conflicts++;

      title = baseTitle + ` ${conflicts + 1}`;
      slug = websiteBuilderSlugify(title);
    }

    void dispatch(websiteBuilderAddPage(
      websiteVersion.id,
      title,
      slug,
      websiteBuilderGenerateDefaultRoot(),
      null,
      t,
      goBackToParentView,
    ));
  }

  function renderAddPageSelectionSection() {
    return (
      <div className="website-builder-add-page-selection-section">
        <button
          className="add-page-selection-page"
          onClick={addBlankPage}
          disabled={disabled}
        >
          <div>{t("Blank page")}</div>
          <FontAwesomeIcon icon={faPlus} className="add-page-selection-page-icon" />
        </button>
      </div>
    );
  }

  function renderAddPageCancelSection() {
    return (
      <Button
        className="website-builder-add-page-cancel-action"
        onClick={goBackToParentView}
      >
        {t("Cancel")}
      </Button>
    );
  }

  return (
    <WebsiteBuilderToolbarMenuView
      title={t("Add page")}
      goBackToParentView={goBackToParentView}
      footer={renderAddPageCancelSection()}
      sections={[
        {
          content: renderAddPageSelectionSection(),
        },
      ]}
    />
  );
}